import React from 'react';
import './FacilityReports.css';
import logComponent from '../../common/logComponent';
import FacilityReports from './FacilityReports';
import { CardReportsProvider } from '../../contexts/CardReportsContext';

export default function FacilityReportsCard({ moduleDescription }) {
  if (logComponent('FacilityReportCard')) { console.debug('FacilityReportCard rendered'); }


  return (
    <CardReportsProvider>
      <FacilityReports moduleDescription={moduleDescription} />
    </CardReportsProvider>
  );
}